import React from 'react';
import { resources } from '../../mock';
import { FileText, BookOpen, ClipboardCheck, Brain } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

const iconMap = { FileText, BookOpen, ClipboardCheck, Brain };

export const ResourcesSection = () => {
  return (
    <section id="resources" className="section" data-testid="resources-section">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4" style={{ color: 'var(--sage-dark)' }}>Patient Resources</h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Educational resources to help you better understand and manage your health.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {resources.map((resource) => {
            const IconComponent = iconMap[resource.icon];
            return (
              <Card key={resource.id} className="hover:shadow-lg transition-shadow" data-testid={`resource-card-${resource.id}`}>
                <CardContent className="p-6">
                  <div className="flex items-start space-x-4">
                    <div className="p-3 rounded-lg flex-shrink-0" style={{ backgroundColor: 'rgba(139, 111, 71, 0.1)' }}>
                      {IconComponent && <IconComponent className="w-6 h-6" style={{ color: 'var(--earth-accent)' }} />}
                    </div>
                    <div>
                      <p className="text-sm font-semibold mb-1" style={{ color: 'var(--earth-accent)' }}>{resource.category}</p>
                      <h3 className="text-lg font-bold mb-2" style={{ color: 'var(--sage-dark)' }}>{resource.title}</h3>
                      <p className="text-gray-600 text-sm">{resource.description}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
